// import '../../node_modules/core-js/index.js'
import React, { useEffect, useState, useCallback } from 'react'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import ReactDOM from 'react-dom'
import DropDown from './DropDown'

import FileUpload from './FileUpload'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import PictureContainer from './PictureContainer'

import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import CircularProgress from '@material-ui/core/CircularProgress'

import { filterBy } from '@progress/kendo-data-query'

import { DropDownList } from '@progress/kendo-react-dropdowns'
import { MultiSelect } from '@progress/kendo-react-dropdowns'

import { AutoComplete, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns'
import { Input } from '@progress/kendo-react-inputs'
import { TextArea } from '@progress/kendo-react-inputs'
import { Label } from '@progress/kendo-react-labels'
import {
    Dialog as KDialog,
    DialogActionsBar as KDialogActionsBar,
} from '@progress/kendo-react-dialogs'
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout'

import { Sortable } from '@progress/kendo-react-sortable'

import './Modals.css'
import { getBaseURL } from '../../GlobalComponents/URLs'

const ATTRIBUTE_SEARCH_URL = `${getBaseURL()}webapi/invtcategoryattribute/acAttributes/`
const ATTRIBUTE_URL = `${getBaseURL()}webapi/inventory/attribute`
const GET_IMAGE_URL = `${getBaseURL()}webapi/inventory/image`
const GET_DELETE_INFO_URL = `${getBaseURL()}webapi/invtcategoryattribute/deleteInfo`
const VENDOR_URL = `${getBaseURL()}webapi/inventory/vendors`

let Sections = ['How To', 'Selection Guides']

function ListItemLink(props) {
    return <ListItem button component="a" target="_blank" {...props} />
}

const AttributeTypeahead2 = (props) => {
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const myRef = React.useRef(null)

    useEffect(() => {
        myRef.current && myRef.current.focus()
    }, [myRef.current])

    const handleSearch = (query) => {
        setLoading(true)

        fetch(`${ATTRIBUTE_SEARCH_URL}/${query}`, { credentials: 'include' })
            .then((resp) => resp.json())
            .then((json) => {
                setOptions(json)
                setLoading(false)
            })
    }

    // careful about focus since hitting "X" on the autocomplete will never trigger blur
    const onChange = (event) => {
        if (event.target.value !== '') {
            handleSearch(event.target.value)
        }
        props.onChange(event.target.value)
    }

    return (
        <AutoComplete
            data={options}
            label={'Attribute'}
            ref={myRef}
            onBlur={props.validate}
            onChange={onChange}
            value={props.value}
            style={{ width: '90%' }}
        />
    )
}

export const OneFieldModal = (props) => {
    const [catName, setCatName] = useState(props.default || '')

    return (
        <KDialog title={props.title} onClose={props.close} width={400}>
            <p>{props.text}</p>
            <TextField
                id="standard-basic"
                label="CategoryName"
                inputRef={(input) => input && input.focus()}
                value={catName}
                style={{ width: 350 }}
                onChange={(val) => {
                    setCatName(val.target.value)
                }}
            />
            <KDialogActionsBar>
                <button className="k-button k-primary" onClick={props.close}>
                    Cancel
                </button>
                <button className="k-button" onClick={() => props.submit(catName)}>
                    {props.submitText}
                </button>
            </KDialogActionsBar>
        </KDialog>
    )
}
export const NoFieldModal = (props) => {
    const useStyles = makeStyles({
        root: {
            maxWidth: 400,
            display: 'flex',
        },
        content: {
            maxWidth: 350,
        },
        media: {
            marginTop: 20,
            height: 70,
            backgroundSize: 'contain',
        },
    })

    const classes = useStyles()

    return ReactDOM.createPortal(
        <div
            className="modal"
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <div className="row">
                <Card className={classes.root}>
                    <div style={{ flexDirection: 'column', marginLeft: 20, marginTop: 20 }}>
                        <CardContent className={classes.content}>
                            <Typography gutterBottom variant="h5" component="h2">
                                {props.title}
                            </Typography>
                        </CardContent>
                        <CardActions style={{ flexDirection: 'row-reverse', width: 400 }}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={props.close}
                                style={{ margin: 20, marginRight: 60 }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => props.submit()}
                                style={{ margin: 20, marginRight: 60 }}
                            >
                                {props.submitText}
                            </Button>
                        </CardActions>
                    </div>
                </Card>
            </div>
        </div>,
        document.getElementById('modal-root')
    )
}

export const DeleteCatModal = ({ close, submit, categoryId, categoryName }) => {
    const [loaded, setLoaded] = useState(false)
    const [deleteInfo, setDeleteInfo] = useState(false)
    React.useEffect(() => {
        window.inModal = true
        return () => (window.inModal = false)
    }, [])
    const getDeleteInfo = async (categoryId) => {
        let response = await fetch(`${GET_DELETE_INFO_URL}/${categoryId}`, {
            credentials: 'include',
        })
        if (response.ok) {
            let json = await response.json()
            setDeleteInfo(json)
            setLoaded(true)
        } else {
            alert('Failed to get Delete Info')
            close()
        }
    }
    React.useEffect(() => {
        getDeleteInfo(categoryId)
    }, [])

    return (
        <KDialog title={'DELETE?'} onClose={close} width={400}>
            {loaded ? (
                <p>{`Deleting the category "${categoryName}" will delete (${
                    deleteInfo.CategoryCount - 1
                }) subcategories and decategorize (${deleteInfo.PartCount}) associated parts.`}</p>
            ) : (
                ''
            )}
            <KDialogActionsBar>
                <button className="k-button k-primary" onClick={close}>
                    Cancel
                </button>
                <button className="k-button" onClick={() => submit(deleteInfo)}>
                    {'DELETE'}
                </button>
            </KDialogActionsBar>
        </KDialog>
    )
}

export const MoveOrMergeModal = (props) => {
    React.useEffect(() => {
        window.inModal = true
        return () => (window.inModal = false)
    }, [])
    let title = 'Move or Merge?'
    if (props.mergeDisabled) title = 'Move?'
    else if (props.moveDisabled) title = 'Merge?'
    return (
        <KDialog title={title} onClose={props.close} width={400}>
            <div style={{ flexDirection: 'column', width: '100%' }}>
                <div style={{ flexDirection: 'row', display: 'flex', width: '100%' }}>
                    <div
                        style={{
                            flexDirection: 'column',
                            display: 'flex',
                            flex: props.mergeDisabled ? '0.5 1 100%' : 0.5,
                            width: '50%',
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: props.moveDisabled ? 'none' : '',
                        }}
                    >
                        <div style={{ flex: 0.5, overflowWrap: 'break-word' }}>
                            Make{' '}
                            <p
                                style={{
                                    fontWeight: 'bold',
                                    overflowWrap: 'break-word',
                                    display: 'inline',
                                }}
                            >
                                {props.sourceNode}
                            </p>{' '}
                            a child category of{' '}
                            <p
                                style={{
                                    fontWeight: 'bold',
                                    overflowWrap: 'break-word',
                                    display: 'inline',
                                }}
                            >
                                {props.destNode}
                            </p>
                        </div>
                    </div>
                    <div
                        style={{
                            flexDirection: 'column',
                            display: 'flex',
                            flex: props.moveDisabled ? '0.5 1 100%' : 0.5,
                            width: '50%',
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: props.mergeDisabled ? 'none' : '',
                        }}
                    >
                        <div style={{ flex: 0.5, overflowWrap: 'break-word' }}>
                            Merge{' '}
                            <p
                                style={{
                                    fontWeight: 'bold',
                                    overflowWrap: 'break-word',
                                    display: 'inline',
                                }}
                            >
                                {props.sourceNode}
                            </p>{' '}
                            into{' '}
                            <p
                                style={{
                                    fontWeight: 'bold',
                                    overflowWrap: 'break-word',
                                    display: 'inline',
                                }}
                            >
                                {props.destNode}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <KDialogActionsBar>
                <button className="k-button k-primary" onClick={props.move}>
                    Move
                </button>
                <button className="k-button" onClick={props.merge}>
                    Merge
                </button>
            </KDialogActionsBar>
        </KDialog>
    )
}

const cleanName = (text) => {
    return text.replace(/\s+/g, ' ')
}
export const AttributeModal = (props) => {
    React.useEffect(() => {
        window.inModal = true
        return () => (window.inModal = false)
    }, [])

    // fields that are on all categories linked to the attribute
    const DEFAULT_LOCKED_FIELDS = ['ExcelFilter', 'Title', 'Type', 'AttributeSchemas']

    const ATTRIBUTE_TYPE_OPTIONS = [
        { key: 4, value: 'Decimal', text: 'Decimal' },
        { key: 2, value: 'Hyperlink', text: 'Hyperlink' },
        { key: 1, value: 'Integer', text: 'Integer' },
        { key: 7, value: 'String', text: 'String' },
    ]

    const ATTRIBUTE_VALIDATION_OPTIONS = [
        { key: 4, value: 'Pressure', text: 'Pressure' },
        { key: 2, value: 'Pressure Range', text: 'Pressure Range' },
        { key: 1, value: 'GroupIfExist|Certificates', text: 'GroupIfExist|Certificates' },
    ]

    const [changed, setChanged] = useState(false)
    const fakeRerender = () => {
        setChanged((changed) => !changed)
    }

    const attInfo = React.useRef({
        Title: '',
        Hidden: false,
        Type: '',
        ExcelFilter: false,
        DocMap: '',
        Validation: '',
    })
    const [aysncLoading, setAsyncLoading] = useState(false)
    const [attributeResolved, setAttributeResolved] = useState(false)
    const [systemWideEditable, setSystemWideEditable] = useState(false)

    useEffect(() => {
        if (props.attribute) {
            attInfo.current.Title = props.attribute.Title
            attInfo.current.ExcelFilter = props.attribute.ExcelFilter
            attInfo.current.Hidden = props.attribute.Hidden
            attInfo.current.Type = props.attribute.Type
            attInfo.current.Validation = props.attribute.Validation
            attInfo.current.DocMap = props.attribute.DocMap
            attInfo.current.width = props.attribute.width
            if (props.attribute.originalAttribute) {
                attInfo.current.originalAttribute = props.attribute.originalAttribute
            } else {
                delete attInfo.current.originalAttribute
            }
            if (props.attribute.Item) {
                attInfo.current.Item = props.attribute.Item
            } else {
                delete attInfo.current.Item
            }
            setAttributeResolved(true)
            fakeRerender()
        }
    }, [props.attribute])

    let title = 'Attribute Details:'

    return (
        <KDialog title={title} onClose={props.close} width={400}>
            <div style={{ width: '80%' }}>
                <AttributeTypeahead2
                    label="Category Name"
                    fullWidth={true}
                    value={attInfo.current.Title}
                    disabled={!props.titleEditable}
                    required={false}
                    onChange={(value) => {
                        attInfo.current.Title = cleanName(value)
                        fakeRerender()
                        setAttributeResolved(false)
                    }}
                    onInputChange={(value) => {
                        attInfo.current.Title = cleanName(value)
                        setAttributeResolved(false)
                        fakeRerender()
                    }}
                    passLoading={(loading) => setAsyncLoading(loading)}
                    validate={() => {
                        if (props.attribute && attInfo.current.Title === props.attribute.Title)
                            return
                        if (
                            props.currentAttributes.filter(
                                (x) =>
                                    x.Title &&
                                    x.Title.toUpperCase() ===
                                        attInfo.current.Title.trim().toUpperCase()
                            ).length > 0
                        ) {
                            alert('An attribute by that name is already in the category')
                            return
                        }
                        let request_url = `${ATTRIBUTE_URL}/${attInfo.current.Title}`
                        setAsyncLoading(true)
                        fetch(request_url, { credentials: 'include' })
                            .then((resp) => {
                                // brand new
                                if (resp.status === 204) {
                                    attInfo.current.originalAttribute = {}
                                    setAttributeResolved(true)
                                    setSystemWideEditable(true)
                                    return
                                }
                                if (resp.status === 200) {
                                    setAttributeResolved(true)
                                    return resp.json()
                                }
                            })
                            .then((json) => {
                                setAsyncLoading(false)
                                if (json) {
                                    let { Item, ExcelFilter, Title, Type, ArributeSchemas } = json
                                    attInfo.current.ExcelFilter = ExcelFilter
                                    attInfo.current.Item = Item
                                    attInfo.current.Type = Type
                                    attInfo.current.originalAttribute = json
                                    fakeRerender()
                                }
                            })
                    }}
                />
                <div style={{ display: attributeResolved ? '' : 'none' }}>
                    <div style={{ marginTop: 10 }}>
                        <input
                            name={'HiddenBit'}
                            id={'HiddenBit'}
                            checked={attInfo.current.Hidden}
                            onChange={(e) => {
                                attInfo.current.Hidden = e.target.checked
                                fakeRerender()
                            }}
                            type="checkbox"
                        />
                        <label className="form-check-label" style={{ marginLeft: 10 }}>
                            Hidden
                        </label>
                    </div>
                    <div style={{ marginTop: 10 }}>
                        Validation:{' '}
                        <DropDownList
                            data={ATTRIBUTE_VALIDATION_OPTIONS}
                            value={ATTRIBUTE_VALIDATION_OPTIONS.find(
                                (option) => option.value === attInfo.current.Validation
                            )}
                            textField={'text'}
                            onChange={(e) => {
                                attInfo.current.Validation = e.value.value
                                fakeRerender()
                            }}
                        />
                    </div>
                    <Label
                        style={{ verticalAlign: 'middle', lineHeight: 2, marginRight: 10 }}
                        editorId="aDocMap"
                    >
                        Doc Map:{' '}
                    </Label>
                    <Input
                        id="aDocMap"
                        style={{ flex: 1, marginTop: 10 }}
                        value={attInfo.current.DocMap}
                        onChange={(val) => {
                            attInfo.current.DocMap = val.target.value
                            fakeRerender()
                        }}
                    />
                    {!systemWideEditable && (
                        <div style={{ marginTop: 10 }} onClick={() => setSystemWideEditable(true)}>
                            Click here to allow editing of fields that affect other categories
                        </div>
                    )}
                    <div
                        style={{
                            backgroundColor: systemWideEditable ? 'unset' : '#e9ecef',
                            borderRadius: 5,
                            marginTop: 10,
                            padding: 10,
                        }}
                    >
                        <div>
                            Type:{' '}
                            <DropDownList
                                data={ATTRIBUTE_TYPE_OPTIONS}
                                textField={'text'}
                                value={ATTRIBUTE_TYPE_OPTIONS.find(
                                    (option) => option.value === attInfo.current.Type
                                )}
                                onChange={(e) => {
                                    attInfo.current.Type = e.value.value
                                    fakeRerender()
                                }}
                                disabled={!systemWideEditable}
                            />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <input
                                name={'ExcelFilter'}
                                id={'ExcelFilter'}
                                checked={attInfo.current.ExcelFilter}
                                onChange={(e) => {
                                    attInfo.current.ExcelFilter = e.target.checked
                                    fakeRerender()
                                }}
                                type="checkbox"
                                disabled={!systemWideEditable}
                            />
                            <label className="form-check-label" style={{ marginLeft: 10 }}>
                                Filter Bit
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <KDialogActionsBar>
                <button className="k-button" onClick={props.close}>
                    Close
                </button>
                {attributeResolved ? (
                    <button
                        variant="contained"
                        className={aysncLoading ? 'k-button' : 'k-button k-primary'}
                        onClick={
                            aysncLoading
                                ? null
                                : () => {
                                    let requiredFields = ['Type', 'Title'] //"DocMap", "Validation"
                                    let missingFields = requiredFields.filter(
                                        (x) => !attInfo.current[x]
                                    )
                                    if (missingFields.length > 0) {
                                        let missingString = missingFields.join('\n')
                                        alert('All fields are required:\n' + missingString)
                                        return
                                    }
                                    props.submit(JSON.parse(JSON.stringify(attInfo.current)))
                                }
                        }
                    >
                        {props.submitText}
                    </button>
                ) : (
                    <button
                        variant="contained"
                        className={aysncLoading ? 'k-button' : 'k-button k-primary'}
                    >
                        Next
                    </button>
                )}
            </KDialogActionsBar>
        </KDialog>
    )
}
AttributeModal.defaultProps = {
    submitText: 'Save',
}

export function SaveDialog(props) {
    let { handleSave, handleClose, open, handleDiscard } = props

    return (
        <KDialog
            title={'There are unsaved changes in this category'}
            onClose={handleClose}
            width={470}
        >
            <div style={{ textAlign: 'center', verticalAlign: 'center' }}>
                You must save before switching categories
            </div>
            <KDialogActionsBar>
                <button className="k-button k-success" onClick={handleSave}>
                    Save
                </button>
                <button className="k-button" onClick={handleClose}>
                    Keep Editing
                </button>
                <button className="k-button k-danger" onClick={handleDiscard}>
                    Discard
                </button>
            </KDialogActionsBar>
        </KDialog>
    )
}

export const ExternalContentModal = (props) => {
    const { close } = props

    const html_unescape = (string) => {
        var div = document.createElement('div')
        div.innerHTML = string
        return div.textContent || div.innerText
    }

    const useStyles = makeStyles({
        paper: {
            minWidth: 700,
            width: '70%',
            display: 'flex',
            maxHeight: '90%',
        },
        media: {
            marginTop: 20,
            height: 70,
            backgroundSize: 'contain',
        },
    })

    const useTextStyles = makeStyles({
        primary: {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            height: '100%',
            maxWidth: '95%',
            display: 'inline-block',
            whiteSpace: 'nowrap',
            marginTop: 7,
        },
    })
    const [selectedTab, setSelectedTab] = useState(0)
    const [loading, setLoading] = React.useState(true)
    const [tagOptions, setTagOptions] = React.useState([])
    const [posts, setPosts] = React.useState([])
    const [viewPosts, setViewPosts] = useState([])
    const [viewTags, setViewTags] = useState([])
    const [category, setCategory] = React.useState(props.category)
    const tagURL = 'https://www.awc-inc.com/wp-json/wp/v2/tags'
    const postURL = 'https://www.awc-inc.com/wp-json/wp/v2/posts'

    const getTagsRecursive = async (page, count, data) => {
        let url = `${tagURL}?page=${page}&per_page=${count}`
        let resp = await fetch(url, { credentials: 'include' })
        if (resp.ok) {
            let json = await resp.json()
            if (json.length === 0) {
                let newTags = data.map((info) => ({ value: info.id, text: info.name }))
                newTags.sort((a, b) => (a.text < b.text ? -1 : 1))
                setTagOptions(newTags)
                setViewTags(newTags)
            } else {
                let newData = [...data, ...json]
                getTagsRecursive(page + 1, count, newData)
                return Promise.resolve(true)
            }
        }
    }

    const getPostsRecursive = async (page, count, data) => {
        let url = `${postURL}?page=${page}&per_page=${count}`
        let resp = await fetch(url, { credentials: 'include' })
        if (resp.ok) {
            let json = await resp.json()
            let newData = [...data, ...json]
            getPostsRecursive(page + 1, count, newData)
        } else {
            let newPosts = data.map((post) => ({
                value: post.id,
                text: html_unescape(post.title.rendered),
                url: post.link,
                id: post.id,
            }))
            newPosts.sort((a, b) => (a.text < b.text ? -1 : 1))
            setPosts(newPosts)
            setViewPosts(newPosts)
            return Promise.resolve(true)
        }
    }

    const loadInfo = async () => {
        let postPromise = getPostsRecursive(1, 100, [])
        let tagPromise = getTagsRecursive(1, 100, [])
        let promises = [postPromise, tagPromise]
        await Promise.all(promises)
        setLoading(false)
    }

    React.useEffect(() => {
        // use this in keydown events to tell if in modal
        window.inModal = true
        loadInfo()
        return () => (window.inModal = false)
    }, [])

    React.useEffect(() => {
        Sections.forEach((section) => {
            category.ExternalContent.Posts[section].forEach((post, i) => (post.OrderBy = i))
        })

        props.categoryRef.current = category
    }, [category])

    const classes = useStyles()
    const textClasses = useTextStyles()

    const SortableItemUI = (props) => {
        const { isDisabled, isActive, style, attributes, dataItem, forwardRef } = props
        const classNames = ['col-xs-6 col-sm-3']

        return (
            <div ref={forwardRef} {...attributes} style={style}>
                <ListItemLink href={dataItem.url} style={{ height: 50 }}>
                    <ListItemText primary={dataItem.text} classes={textClasses} />
                    <div style={{ flex: '0 0 30px' }}>
                        <div
                            onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                dataItem.onXClick(dataItem.value)
                            }}
                            style={{
                                fontSize: 20,
                                display: 'inline-block',
                            }}
                            onMouseDown={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            }}
                            className="k-icon k-i-close-outline k-i-x-outline"
                        />
                    </div>
                </ListItemLink>
            </div>
        )
    }

    const onSortableDragOver = (event, section) => {
        setCategory((category) => {
            let values = event.newState
            category.ExternalContent.Posts[section] = values
            return { ...category }
        })
    }

    const onNavigate = (event) => {
        setCategory((category) => {
            let values = event.newState
            category.ExternalContent.Posts = values
            return { ...category }
        })
    }

    const handleSelect = (e) => {
        setViewPosts(posts)
        setViewTags(tagOptions)
        setSelectedTab(e.selected)
    }

    const onSortableXClick = (value, section) =>
        setCategory((category) => {
            category.ExternalContent.Posts[section] = category.ExternalContent.Posts[
                section
            ].filter((x) => x.value != value)
            return { ...category }
        })

    return (
        <div>
            <KDialog
                open={true}
                classes={classes}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                onClose={close}
                title={'External Content'}
                width={'45%'}
            >
                <TabStrip selected={selectedTab} onSelect={handleSelect}>
                    <TabStripTab title="Selection Guides">
                        <DialogContentText
                            id="scroll-dialog-description"
                            tabIndex={-1}
                            style={{
                                whiteSpace: 'pre-wrap',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        ></DialogContentText>
                        {loading ? (
                            <CircularProgress
                                style={{ position: 'relative', left: 'calc(50% - 20px)' }}
                            />
                        ) : (
                            <>
                                <div
                                    className="mInfo"
                                    style={{
                                        marginTop: 10,
                                        flex: '0 0 auto',
                                    }}
                                >
                                    <div className="mExLabelContainer">
                                        <Label
                                            style={{
                                                verticalAlign: 'middle',
                                                lineHeight: 2,
                                                marginRight: 10,
                                                fontWeight: 500,
                                            }}
                                            editorId="cdDisplayOrder"
                                        >
                                            Tags:{' '}
                                        </Label>
                                    </div>

                                    <MultiSelect
                                        value={tagOptions.filter((x) =>
                                            category.ExternalContent.Tags['Selection Guides'].find(
                                                (y) => y.value == x.value
                                            )
                                        )}
                                        onChange={(e) => {
                                            setCategory((category) => {
                                                let values = e.value
                                                category.ExternalContent.Tags['Selection Guides'] =
                                                    values
                                                return { ...category }
                                            })
                                            setViewTags(tagOptions)
                                        }}
                                        placeholder="Choose a Tag"
                                        focusedItemIndex={(data, inputText, textField) => {
                                            let text = inputText.toLowerCase()
                                            return data.findIndex((item) =>
                                                item['text'].includes(text)
                                            )
                                        }}
                                        onFilterChange={(event) => {
                                            setViewTags(filterBy(tagOptions.slice(), event.filter))
                                        }}
                                        filterable={true}
                                        id="mTech"
                                        textField={'text'}
                                        data={viewTags}
                                        // id={'cdTech'}
                                    />
                                </div>
                                <div
                                    className="mInfo"
                                    style={{
                                        marginTop: 10,
                                        flex: '0 0 auto',
                                    }}
                                >
                                    <div className="mExLabelContainer">
                                        <Label
                                            style={{
                                                verticalAlign: 'middle',
                                                lineHeight: 2,
                                                marginRight: 10,
                                                fontWeight: 500,
                                            }}
                                            editorId="cdDisplayOrder"
                                        >
                                            Posts:{' '}
                                        </Label>
                                    </div>

                                    <MultiSelect
                                        value={posts.filter((x) =>
                                            category.ExternalContent.Posts['Selection Guides'].find(
                                                (y) => y.value == x.value
                                            )
                                        )}
                                        className={'hiddenX'}
                                        onChange={(e) => {
                                            if (e.value.length === 0) return
                                            setCategory((category) => {
                                                let values = e.value
                                                // keep order right
                                                if (values.length > 0)
                                                    category.ExternalContent.Posts[
                                                        'Selection Guides'
                                                    ] = [
                                                        ...category.ExternalContent.Posts[
                                                            'Selection Guides'
                                                        ],
                                                        values[values.length - 1],
                                                    ]
                                                else
                                                    category.ExternalContent.Posts[
                                                        'Selection Guides'
                                                    ] = []
                                                return { ...category }
                                            })
                                            // // reset view
                                            setViewPosts(posts)
                                        }}
                                        placeholder="Choose a Blog"
                                        focusedItemIndex={(data, inputText, textField) => {
                                            let text = inputText.toLowerCase()
                                            return data.findIndex((item) =>
                                                item['text'].includes(text)
                                            )
                                        }}
                                        onFilterChange={(event) => {
                                            setViewPosts(filterBy(posts.slice(), event.filter))
                                        }}
                                        filterable={true}
                                        id="mPosts"
                                        textField={'text'}
                                        dataItemKey={'id'}
                                        data={viewPosts}
                                        // id={'cdTech'}
                                        tags={null}
                                    />
                                </div>

                                <Sortable
                                    idField={'id'}
                                    disabledField={'disabled'}
                                    data={category.ExternalContent.Posts['Selection Guides']
                                        .filter((x) => posts.find((y) => y.value == x.value))
                                        .map((x) => posts.find((y) => y.value == x.value))
                                        .map((row) => ({
                                            ...row,
                                            onXClick: (value) =>
                                                onSortableXClick(value, 'Selection Guides'),
                                        }))}
                                    itemUI={SortableItemUI}
                                    onDragOver={(e) => onSortableDragOver(e, 'Selection Guides')}
                                    onNavigate={onNavigate}
                                    style={{ maxHeight: '30vh', overflowY: 'auto' }}
                                />
                            </>
                        )}
                    </TabStripTab>
                    <TabStripTab title="How To">
                        <DialogContentText
                            id="scroll-dialog-description"
                            tabIndex={-1}
                            style={{
                                whiteSpace: 'pre-wrap',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        ></DialogContentText>
                        {loading ? (
                            <CircularProgress
                                style={{ position: 'relative', left: 'calc(50% - 20px)' }}
                            />
                        ) : (
                            <>
                                <div
                                    className="mInfo"
                                    style={{
                                        marginTop: 10,
                                        flex: '0 0 auto',
                                    }}
                                >
                                    <div className="mExLabelContainer">
                                        <Label
                                            style={{
                                                verticalAlign: 'middle',
                                                lineHeight: 2,
                                                marginRight: 10,
                                                fontWeight: 500,
                                            }}
                                            editorId="cdDisplayOrder"
                                        >
                                            Tags:{' '}
                                        </Label>
                                    </div>

                                    <MultiSelect
                                        value={tagOptions.filter((x) =>
                                            category.ExternalContent.Tags['How To'].find(
                                                (y) => y.value == x.value
                                            )
                                        )}
                                        onChange={(e) => {
                                            setCategory((category) => {
                                                let values = e.value
                                                category.ExternalContent.Tags['How To'] = values
                                                return { ...category }
                                            })
                                            setViewTags(tagOptions)
                                        }}
                                        placeholder="Choose a Tag"
                                        focusedItemIndex={(data, inputText, textField) => {
                                            let text = inputText.toLowerCase()
                                            return data.findIndex((item) =>
                                                item['text'].includes(text)
                                            )
                                        }}
                                        onFilterChange={(event) => {
                                            setViewTags(filterBy(tagOptions.slice(), event.filter))
                                        }}
                                        filterable={true}
                                        id="mTech"
                                        textField={'text'}
                                        data={viewTags}
                                        // id={'cdTech'}
                                    />
                                </div>
                                <div
                                    className="mInfo"
                                    style={{
                                        marginTop: 10,
                                        flex: '0 0 auto',
                                    }}
                                >
                                    <div className="mExLabelContainer">
                                        <Label
                                            style={{
                                                verticalAlign: 'middle',
                                                lineHeight: 2,
                                                marginRight: 10,
                                                fontWeight: 500,
                                            }}
                                            editorId="cdDisplayOrder"
                                        >
                                            Posts:{' '}
                                        </Label>
                                    </div>

                                    <MultiSelect
                                        value={posts.filter((x) =>
                                            category.ExternalContent.Posts['How To'].find(
                                                (y) => y.value == x.value
                                            )
                                        )}
                                        className={'hiddenX'}
                                        onChange={(e) => {
                                            setCategory((category) => {
                                                let values = e.value
                                                // keep order right
                                                if (values.length > 0)
                                                    category.ExternalContent.Posts['How To'] = [
                                                        ...category.ExternalContent.Posts['How To'],
                                                        values[values.length - 1],
                                                    ]
                                                else category.ExternalContent.Posts['How To'] = []
                                                return { ...category }
                                            })
                                            // reset view
                                            setViewPosts(posts)
                                        }}
                                        placeholder="Choose a Blog"
                                        focusedItemIndex={(data, inputText, textField) => {
                                            let text = inputText.toLowerCase()
                                            return data.findIndex((item) =>
                                                item['text'].includes(text)
                                            )
                                        }}
                                        onFilterChange={(event) => {
                                            setViewPosts(filterBy(posts.slice(), event.filter))
                                        }}
                                        filterable={true}
                                        id="mPosts"
                                        textField={'text'}
                                        dataItemKey={'id'}
                                        data={viewPosts}
                                        // id={'cdTech'}
                                        tags={null}
                                    />
                                </div>

                                <Sortable
                                    idField={'id'}
                                    disabledField={'disabled'}
                                    data={category.ExternalContent.Posts['How To']
                                        .filter((x) => posts.find((y) => y.value == x.value))
                                        .map((x) => posts.find((y) => y.value == x.value))
                                        .map((row) => ({
                                            ...row,
                                            onXClick: (value) => onSortableXClick(value, 'How To'),
                                        }))}
                                    itemUI={SortableItemUI}
                                    onDragOver={(e) => onSortableDragOver(e, 'How To')}
                                    onNavigate={onNavigate}
                                    style={{ maxHeight: '50vh', overflowY: 'auto' }}
                                />
                            </>
                        )}
                    </TabStripTab>
                </TabStrip>
                <KDialogActionsBar>
                    <button className="k-button k-primary" onClick={close}>
                        Close
                    </button>
                </KDialogActionsBar>
            </KDialog>
        </div>
    )
}

export const WebInfoModal = (props) => {
    const { close } = props
    const [category, setCategory] = React.useState(props.category)
    const [selectedTab, setSelectedTab] = useState(0)
    const [viewVendors, setViewVendors] = useState([])
    const [vendors, setVendors] = React.useState([])

    const getVendors = async () => {
        let resp = await fetch(VENDOR_URL, {
            credentials: 'include',
        })
        let json = await resp.json()
        setVendors(json)
        setViewVendors(json)
    }
    React.useEffect(() => {
        window.inModal = true
        getVendors()
        return () => (window.inModal = false)
    }, [])

    React.useEffect(() => {
        props.categoryRef.current = category
    }, [category])

    React.useEffect(() => {
        category.PreferredVendors.forEach((vend, i) => (vend.OrderBy = i))

        props.categoryRef.current = category
    }, [category])

    const handleSelect = (e) => {
        setSelectedTab(e.selected)
    }

    const onSortableXClick = (value) =>
        setCategory((category) => {
            category.PreferredVendors = category.PreferredVendors.filter(
                (x) => x['VENDID'] != value
            )
            return { ...category }
        })

    const SortableItemUI = (props) => {
        const { isDisabled, isActive, style, attributes, dataItem, forwardRef } = props
        const classNames = ['col-xs-6 col-sm-3']

        // if (isDisabled) {
        //     classNames.push('k-state-disabled');
        // }

        return (
            <div
                ref={forwardRef}
                {...attributes}
                style={style}
                // className={classNames.join(' ')}
            >
                <ListItem href={''} style={{ height: 50 }}>
                    <ListItemText primary={dataItem['NAME']} />
                    <div style={{ flex: '0 0 30px' }}>
                        <div
                            onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                dataItem.onXClick(dataItem['VENDID'])
                            }}
                            style={{
                                fontSize: 20,
                                display: 'inline-block',
                            }}
                            onMouseDown={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            }}
                            className="k-icon k-i-close-outline k-i-x-outline"
                        />
                    </div>
                </ListItem>
            </div>
        )
    }

    const onSortableDragOver = (event, section) => {
        setCategory((category) => {
            let values = event.newState
            category.PreferredVendors = values.map((ele, i) => ({
                VENDID: ele['VENDID'],
                OrderBy: i,
            }))
            return { ...category }
        })
    }

    const onNavigate = (event) => {
        setCategory((category) => {
            let values = event.newState
            category.PreferredVendors = values.map((ele, i) => ({
                VENDID: ele['VENDID'],
                OrderBy: i,
            }))
            return { ...category }
        })
    }

    let primaryTechOptions = [
        { key: 4, value: 4, text: 'Instrumentation' },
        { key: 2, value: 2, text: 'Electrical' },
        { key: 1, value: 1, text: 'Factory Automation' },
        { key: 7, value: 7, text: 'Process Automation' },
        { key: 5, value: 5, text: 'Valves/Flow Control' },
    ]

    const useStyles = makeStyles({
        paper: {
            width: '60%',
            minWidth: 500,
            maxWidth: 1500,
            display: 'flex',
        },
        media: {
            marginTop: 20,
            height: 70,
            backgroundSize: 'contain',
        },
    })

    const classes = useStyles()

    return (
        <div>
            <KDialog
                open={true}
                classes={classes}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                title="Web Detail"
                onClose={close}
                width={'40%'}
            >
                <TabStrip selected={selectedTab} onSelect={handleSelect}>
                    <TabStripTab title="Basic">
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div className="mInfo" style={{ marginTop: 10 }}>
                                <div className="mLabelContainer">
                                    <Label
                                        style={{
                                            verticalAlign: 'middle',
                                            lineHeight: 2,
                                            marginRight: 10,
                                            fontWeight: 500,
                                        }}
                                        editorId="cdDisplayOrder"
                                    >
                                        Display Order:{' '}
                                    </Label>
                                </div>

                                <Input
                                    id={'cdDisplayOrder'}
                                    className="form-control form-control-sm"
                                    style={{ width: 100 }}
                                    value={category.DisplayOrder}
                                    onChange={(e) => {
                                        setCategory((category) => {
                                            category.DisplayOrder = e.target.value
                                            return { ...category }
                                        })
                                    }}
                                    // disabled={!canWrite}
                                />
                            </div>

                            <div className="mInfo">
                                <div className="mLabelContainer">
                                    <Label
                                        style={{
                                            verticalAlign: 'middle',
                                            lineHeight: 2,
                                            marginRight: 10,
                                            fontWeight: 500,
                                        }}
                                        editorId={'cdCustomURL'}
                                    >
                                        Custom Web URL:{' '}
                                    </Label>
                                </div>

                                <Input
                                    id={'cdCustomURL'}
                                    className="form-control form-control-sm"
                                    style={{ flex: 1, marginRight: 20 }}
                                    value={category.CustomURL}
                                    onChange={(e) => {
                                        setCategory((category) => {
                                            category.CustomURL = e.target.value
                                            return { ...category }
                                        })
                                    }}
                                    // disabled={!canWrite}
                                />
                            </div>
                            <div
                                className="k-separator"
                                style={{
                                    borderTop: '1px solid rgba(235, 235, 235, 0.8)',
                                    marginTop: 15,
                                    marginBottom: 5,
                                }}
                            ></div>
                            <div
                                className="mInfo"
                                style={{
                                    marginTop: 10,
                                    flex: '0 0 auto',
                                }}
                            >
                                <div className="mLabelContainer">
                                    <Label
                                        style={{
                                            verticalAlign: 'middle',
                                            lineHeight: 2,
                                            marginRight: 10,
                                            fontWeight: 500,
                                        }}
                                        editorId="mPreferredVenodrs"
                                    >
                                        Preferred Vendors:{' '}
                                    </Label>
                                </div>

                                <MultiSelect
                                    value={vendors.filter((x) =>
                                        category.PreferredVendors.find((y) => y.VENDID == x.VENDID)
                                    )}
                                    className={'hiddenX'}
                                    onChange={(e) => {
                                        setCategory((category) => {
                                            let values = e.value
                                            // keep order right
                                            if (values.length > 0)
                                                category.PreferredVendors = [
                                                    ...category.PreferredVendors,
                                                    {
                                                        VENDID: values[values.length - 1]['VENDID'],
                                                        OrderBy: values.length,
                                                    },
                                                ]
                                            else category.PreferredVendors = []
                                            return { ...category }
                                        })
                                        // // reset vio
                                        setViewVendors(vendors)
                                    }}
                                    textField={'NAME'}
                                    // disabled={!canWrite}
                                    placeholder="Choose a Preferred Vendor"
                                    focusedItemIndex={(data, inputText, textField) => {
                                        let text = inputText.toLowerCase()
                                        return data.findIndex((item) => item['NAME'].includes(text))
                                    }}
                                    onFilterChange={(event) => {
                                        setViewVendors(filterBy(vendors.slice(), event.filter))
                                    }}
                                    filterable={true}
                                    id="mPreferredVendors"
                                    dataItemKey={'VENDID'}
                                    data={viewVendors}
                                    // id={'cdTech'}
                                    tags={null}
                                />
                            </div>

                            <Sortable
                                idField={'VENDID'}
                                disabledField={'disabled'}
                                data={category.PreferredVendors.map((x) =>
                                    vendors.find((y) => x.VENDID == y.VENDID)
                                ).map((row) => ({
                                    ...row,
                                    onXClick: (value) => onSortableXClick(value),
                                }))}
                                itemUI={SortableItemUI}
                                onDragOver={(e) => onSortableDragOver(e)}
                                onNavigate={onNavigate}
                                style={{ maxHeight: '50vh', overflowY: 'auto' }}
                            />
                        </div>

                        {/* </div> */}
                    </TabStripTab>
                    <TabStripTab title="Marketing">
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div className="mInfo">
                                <div className="mLabelContainer">
                                    <Label
                                        style={{
                                            verticalAlign: 'middle',
                                            lineHeight: 1,
                                            marginRight: 10,
                                            fontWeight: 500,
                                        }}
                                        editorId={'cdPrimaryTech'}
                                    >
                                        Primary Technology:{' '}
                                    </Label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <DropDownList
                                        defaultValue={primaryTechOptions.find(
                                            (y) => y.value === category.PrimaryTechnology
                                        )}
                                        data={primaryTechOptions}
                                        textField={'text'}
                                        // id={'cdPrimaryTech'}
                                        onChange={(e) => {
                                            // e.persist();
                                            setCategory((category) => {
                                                category.PrimaryTechnology = e.target.value
                                                return { ...category }
                                            })
                                        }}
                                        id="mPtech"
                                        className="mField"
                                        // disabled={!canWrite}
                                    />
                                </div>
                            </div>
                            <div className="mInfo">
                                <div className="mLabelContainer">
                                    <Label
                                        style={{
                                            verticalAlign: 'middle',
                                            lineHeight: 2,
                                            marginRight: 10,
                                            fontWeight: 500,
                                        }}
                                        editorId={'cdTech'}
                                    >
                                        Technologies:{' '}
                                    </Label>
                                </div>
                                <MultiSelect
                                    value={primaryTechOptions.filter((x) =>
                                        category.Technologies.find((y) => y === x.value)
                                    )}
                                    onChange={(e) =>
                                        setCategory((category) => {
                                            let values = e.target.value
                                            category.Technologies = values.map((ele) => ele.value)
                                            return { ...category }
                                        })
                                    }
                                    // disabled={!canWrite}
                                    id="mTech"
                                    textField={'text'}
                                    data={primaryTechOptions}
                                    // id={'cdTech'}
                                />
                            </div>
                            <div className="mInfo">
                                <div className="mLabelContainer">
                                    <Label
                                        style={{
                                            verticalAlign: 'middle',
                                            lineHeight: 2,
                                            marginRight: 10,
                                            fontWeight: 500,
                                        }}
                                        editorId="cdWebmkt"
                                    >
                                        Web Market Statement:{' '}
                                    </Label>
                                </div>

                                <TextArea
                                    id={'cdWebmkt'}
                                    style={{ flex: 3 }}
                                    value={category.MktStatement}
                                    onChange={(e) => {
                                        setCategory((category) => {
                                            category.MktStatement = e.target.value
                                            return { ...category }
                                        })
                                    }}
                                    rows={4}
                                    // disabled={!canWrite}
                                />
                            </div>

                            <div className="mInfo">
                                <div className="mLabelContainer">
                                    <Label
                                        style={{
                                            verticalAlign: 'middle',
                                            lineHeight: 2,
                                            marginRight: 10,
                                            fontWeight: 500,
                                        }}
                                        editorId="cdWebsideHL"
                                    >
                                        Web Side H/L Image:{' '}
                                    </Label>
                                </div>
                                <TextArea
                                    id="mWSHL"
                                    classname="form-control form-control-sm mField"
                                    style={{ flex: 3 }}
                                    value={category.SideMktImageHL}
                                    onChange={(e) => {
                                        e.persist()
                                        setCategory((category) => {
                                            category.SideMktImageHL = e.target.value
                                            return { ...category }
                                        })
                                    }}
                                    rows={2}
                                    // disabled={!canWrite}
                                />
                            </div>
                        </div>
                    </TabStripTab>
                </TabStrip>
                <KDialogActionsBar>
                    <button className="k-button k-primary" onClick={close}>
                        Close
                    </button>
                </KDialogActionsBar>
            </KDialog>
        </div>
    )
}

/**
 *
 * @param {boolean} open
 * @param {func} close
 * @param {str} text
 */
export function ScrollDialog(props) {
    const { text, close } = props

    const descriptionElementRef = React.useRef(null)
    React.useEffect(() => {
        const { current: descriptionElement } = descriptionElementRef
        if (descriptionElement !== null) {
            descriptionElement.focus()
        }
    }, [])
    // {whiteSpace: "pre-wrap"} makes new lines get respected
    // alternatively need to split on \n and map to <p>{line}</p>
    return (
        <div>
            <Dialog
                open={true}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">Error Inserting Values</DialogTitle>
                <DialogContent dividers={true}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        style={{ whiteSpace: 'pre-wrap' }}
                    >
                        {text}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={close} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

/**
 *
 * @param {boolean} open
 * @param {func} close
 * @param {str} text
 */
export function ImageDialog(props) {
    const { src, close, onSave } = props
    const [droppedFile, setDroppedFile] = useState(false)
    const imageRegex = /<img.*?src=['"](.*?)["']/

    const useStyles = makeStyles({
        root: {
            minWidth: 400,
            maxWidth: 800,
            minHeight: 400,
            maxHeight: 800,
            display: 'flex',
        },
        media: {
            marginTop: 20,
            height: 70,
            backgroundSize: 'contain',
        },
    })

    const classes = useStyles()

    const descriptionElementRef = React.useRef(null)
    React.useEffect(() => {
        const { current: descriptionElement } = descriptionElementRef
        if (descriptionElement !== null) {
            descriptionElement.focus()
        }
    }, [])

    // const stopWindowDrop = (e) => {
    //   e.preventDefault()
    //   e.stopPropagation()
    // }
    // React.useEffect(()=>{
    //   window.addEventListener("drop", stopWindowDrop)
    //   return () => window.removeEventListener("drop", stopWindowDrop)
    // }, [])

    // React.useEffect(()=>{
    //   document.addEventListener("drop", stopWindowDrop)
    //   return () => document.removeEventListener("drop", stopWindowDrop)
    // }, [])

    const onDrop = (e) => {
        e.stopPropagation()
        e.preventDefault()
        let reader = new FileReader()
        reader.addEventListener(
            'load',
            function () {
                let uri = reader.result
                setDroppedFile({ content: uri })
            },
            false
        )
        let haveImage = false
        if (e.dataTransfer.files.length > 0 && e.dataTransfer.files[0].type.includes('image')) {
            haveImage = true
            reader.readAsDataURL(e.dataTransfer.files[0])
        } else if (e.dataTransfer.items.length > 0) {
            haveImage = true
            let data = e.dataTransfer.items
            for (var i = 0; i < data.length; i++) {
                if (data[i].kind == 'string' && data[i].type.match('^text/html')) {
                    // Drag data item is HTML
                    data[i].getAsString(function (s) {
                        let src = imageRegex.exec(s)
                        if (src) {
                            haveImage = true
                            // let downloadedImg = new Image
                            // downloadedImg.crossOrigin = "Anonymous";
                            // downloadedImg.src = src[1];
                            fetch(GET_IMAGE_URL, {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(src[1]),
                            })
                                .then((resp) => {
                                    if (resp.ok) return resp.json()
                                    else throw new Error('Failed to get image')
                                })
                                .then((text) => {
                                    setDroppedFile({ content: text })
                                })
                                .catch((e) => {
                                    alert(e)
                                })

                            return
                        }
                    })
                } else if (data[i].kind == 'string' && data[i].type.match('^text/uri-list')) {
                    // Drag data item is URI
                    // data[i].getAsString(function (s) {
                    //     console('... Drop: URI = ' + s)
                    // })
                }
            }
        }
        if (!haveImage) {
            alert('Dropped file is not an image')
        }
    }

    // {whiteSpace: "pre-wrap"} makes new lines get respected
    // alternatively need to split on \n and map to <p>{line}</p>
    return (
        <div
            onDrop={(e) => {
                e.preventDefault()
                e.stopPropagation()
            }}
        >
            <Dialog
                open={true}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                // classes={classes}
            >
                {/* <DialogTitle id="scroll-dialog-title">Picture</DialogTitle> */}
                <DialogContent dividers={true} classes={classes}>
                    {/* <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            style={{whiteSpace: "pre-wrap"}}
          > */}
                    <PictureContainer
                        src={droppedFile ? droppedFile.content : src}
                        onDrop={onDrop}
                        handleFile={(file) => setDroppedFile({ content: file })}
                    />

                    {/* </DialogContentText> */}
                </DialogContent>
                <DialogActions style={{ justifyContent: 'space-between' }}>
                    <Button
                        onClick={() => {
                            droppedFile && onSave(droppedFile.content)
                            close()
                        }}
                        color="primary"
                    >
                        Save
                    </Button>
                    <FileUpload
                        materialui
                        color="primary"
                        handleFile={(file) => setDroppedFile({ content: file })}
                    />
                    <Button
                        onClick={() => {
                            setDroppedFile({ content: '' })
                        }}
                        color="secondary"
                    >
                        Delete
                    </Button>
                    <Button onClick={close} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
